import { Card, Col, Image, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { CustomText } from 'components/CustomText';
import CustomButton from 'components/CustomButton';
import addSign from 'assets/pngs/add.png';
import CustomInput from 'components/CustomInput';

const PaymentMethodSection = ({
  payMethod,
  setFreeze,
  setPaymentMethodVisible,
  voucherDetails,
  voucherCoversAll,
  paidAmount,
  values,
  errors,
  handleChange,
}) => {
  return (
    <>
      <Col lg={12} className="mt-2 ">
        <Card className="border-0 mt-2 mt-xl-0 mb-4 mb-lg-0 mb-md-0">
          <Card.Header>
            <Row>
              <Col>
                <CustomText
                  fontFamily={'Poppins'}
                  fontSize={14}
                  fontWeight={500}
                  text={'PAYMENT METHOD'}
                />
              </Col>
              {!!payMethod && (
                <Col className="ms-auto d-flex justify-content-end">
                  <CustomButton
                    buttonTextColor={'text-primary'}
                    text="CHANGE"
                    variant="primary"
                    fontWeight={500}
                    fontSize={14}
                    style={{
                      padding: 0,
                      height: 20,
                      backgroundColor: 'transparent',
                      border: 'none',
                    }}
                    className="d-flex justify-content-end"
                    onPress={() => {
                      setFreeze(false);
                      setPaymentMethodVisible(true);
                    }}
                  />
                </Col>
              )}
            </Row>
          </Card.Header>
          <Card.Body className="py-3">
            {!!paidAmount && (
              <CustomText
                fontFamily={'Poppins'}
                fontSize={14}
                cNColor="text-success"
                divClassName="mb-3"
              >
                Your {paidAmount} payment went through. Press Confirm to finish
                placing this order; it can only use this payment while the total
                and payment method stay the same. Need a refund?{' '}
                <Link to="/help">Contact support</Link>.
              </CustomText>
            )}
            {!!voucherDetails && voucherCoversAll ? (
              <Row>
                <CustomText
                  fontFamily={'Poppins'}
                  fontSize={14}
                  // onPress={() => setPaymentMethodVisible(true)}
                >
                  Other payment methods are disabled since the voucher balance
                  will cover the total payment.
                </CustomText>
              </Row>
            ) : (
              <>
                {!payMethod && (
                  <CustomText
                    fontFamily={'Poppins'}
                    fontSize={14}
                    fontWeight={400}
                    cNColor="text-primary"
                    onPress={() => setPaymentMethodVisible(true)}
                  >
                    <Image src={addSign} style={{ marginRight: 16 }} />
                    Select payment method
                  </CustomText>
                )}
                {payMethod && (
                  <Row>
                    <Col xs="auto" className="me-2">
                      {payMethod?.svg}
                    </Col>
                    <Col>
                      <CustomText fontFamily={'Poppins'} fontSize={14}>
                        {payMethod?.altname || payMethod?.name}
                      </CustomText>
                    </Col>
                  </Row>
                )}
                {payMethod && payMethod?.name?.toLowerCase() == 'pay4me' && (
                  <Pay4MeComponent
                    values={values}
                    errors={errors}
                    handleChange={handleChange}
                  />
                )}
              </>
            )}
          </Card.Body>
        </Card>
      </Col>
    </>
  );
};

const Pay4MeComponent = ({ values, errors, handleChange }) => {
  return (
    <Row className="mt-3 mb-2">
      <CustomInput
        label={'Recipient email address'}
        placeholder="Email address"
        id="pay4MeEmail"
        onChange={handleChange('pay4MeEmail')}
        value={values.pay4MeEmail}
        error={errors?.pay4MeEmail}
      />
    </Row>
  );
};

export default PaymentMethodSection;
